<template>
  <div>
    <el-page-header @back="goBack" content="分享设置"></el-page-header>
    <div class="topic-outer">
      <div class="appraisal-center fonts">
        <div class="pub-line">
          <span>分类：</span>
          <span class="glay"
          >{{ detalisObj.categoryName1 }}-{{ detalisObj.categoryName }}</span
          >
        </div>
        <div class="flex-box pub-line">
          <div class="fl1">
            <span>名称：</span>
            <span class="glay">{{ detalisObj.name }}</span>
          </div>
          <div class="fl1">
            <span> 标识：</span>
            <span class="glay">{{ detalisObj.examId }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="topic-outer">
      <div class="ShareContentBox">
        <div class="Share_tabs">
          <div class="left_names">分享方式：</div>
          <div class="changButton">
            <div @click="changTabs(item)" :class="{'activeShareItem':item.value ==shareValue}" class="shareWayItem"
                 v-for="(item,index) in shareWay" :key="index">{{ item.name }}
            </div>
          </div>
        </div>
        <div class="content_tabs" v-if="shareValue=='common'">
          <div class="common_tab_list" v-if="params.shareThemeId">
            <div class="left_names">主题ID：</div>
            <div class="changButton">{{ params.shareThemeId }}</div>
          </div>
          <div class="common_tab_list">
            <div class="left_names"><span style="color: #F56C6C;margin-right: 5px">*</span>图标：</div>
            <div class="changButton">
              <div class="diplay" style="margin-right: 10px">
                <div class="screenshot">
                <span
                    v-for="(imgUrl, index) in srcList"
                    :key="index"
                    class="slideshow"
                >
                  <el-image
                      style="width: 75px; height: 75px; border-radius: 6px"
                      :src="imgUrl"
                      fit="cover"
                      @click="getPolicy"
                  />
                </span>
                  <div
                      class="up-btn"
                      style="width: 75px; height: 75px; line-height: 80px"
                      @click="getPolicy"
                      v-if="isMoer && srcList.length<1"
                  >
                    <i class="el-icon-plus"></i>
                  </div>
                </div>
                <input
                    type="file"
                    ref="file"
                    @change="getFile"
                    accept="image/png,image/jpg"
                />
              </div>
            </div>
          </div>
          <div class="common_tab_list">
            <div class="left_names"><span style="color: #F56C6C;margin-right: 5px">*</span>标题：</div>
            <div class="changButton">
              <el-input style="width: 251px" v-model="params.title" placeholder="请输入内容"></el-input>
            </div>
          </div>
          <div class="common_tab_list">
            <div class="left_names"><span style="color: #F56C6C;margin-right: 5px">*</span>描述：</div>
            <div class="changButton">
              <el-input type="textarea" style="width: 251px" :rows="4" v-model="params.intro"
                        placeholder="请输入内容"></el-input>
            </div>
          </div>
          <el-button style="margin-left: 80px" type="primary" @click="shareSave">编辑</el-button>
        </div>
        <div class="content_tabs" v-if="shareValue=='poster'">
          <div style="margin-left: 80px">
            <el-button style="margin-bottom: 20px" type="primary" @click="handleClick('add')">新增</el-button>
            <el-table
                ref="multipleTable"
                size="medium"
                :data="tableData"
                border
                style="width: 100%"
                row-key="menuId"
                v-loading="loading"
            >
              <el-table-column type="index" label="排序" width="80" align="center">
              </el-table-column>
              <el-table-column prop="shareThemeId" label="主题ID" width="100" align="center">
              </el-table-column>
              <el-table-column prop="title" label="海报" width="100" align="center">
                <template slot-scope="scope">
                  <div style="width: 80%;margin: 0 auto;max-height: 40px">
                    <img :src="scope.row.img" style="object-fit: contain;width: 100%">
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="title" label="标题" width="200" align="center">
              </el-table-column>
              <el-table-column prop="intro" label="描述" width="330" align="center">
              </el-table-column>
              <el-table-column prop="seq" label="排序" width="80" align="center">
              </el-table-column>
              <el-table-column prop="code" label="状态" width="80" align="center">
                <template slot-scope="scope">
                  <el-switch
                      v-model="scope.row.status"
                      :active-value="1"
                      :inactive-value="0"
                      @change="changeSwitch(scope.row)"
                  >
                  </el-switch>
                </template>
              </el-table-column>
              <el-table-column prop="ctime" label="时间" width="180" align="center"></el-table-column>

              <el-table-column fixed="right" label="操作" align="center" width="160" min-width="200">
                <template slot-scope="scope">
                  <el-button
                      style="margin-bottom: 10px"
                      size="mini"
                      @click="handleClick('edit',scope.row)"
                      type="success"
                      plain
                  >编辑
                  </el-button
                  >
                  <el-button
                      size="mini"
                      @click="handleDelete(scope.row)"
                      type="warning"
                      plain
                  >删除
                  </el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
    <!-- 编辑弹框 -->
    <el-dialog
        title="新增/编辑分享主题"
        :visible.sync="dialogVisible"
        width="460px"
        top="30px"
        :close-on-click-modal="false"
        class="public-dialog"
    >
      <div class="public-dialog-form">
        <div class="common_tab_list" v-if="posterParams.shareThemeId">
          <div class="left_names">主题ID：</div>
          <div class="changButton">{{ posterParams.shareThemeId }}</div>
        </div>
        <div class="common_tab_list">
          <div class="left_names"><span style="color: #F56C6C;margin-right: 5px">*</span>海报：</div>
          <div class="changButton">
            <div class="diplay" style="margin-right: 10px">
              <div class="screenshot">
                <span
                    v-for="(imgUrl, index) in posterSrcList"
                    :key="index"
                    class="slideshow"
                >
                  <el-image
                      style="width: 75px; height: 75px; border-radius: 6px"
                      :src="imgUrl"
                      fit="cover"
                      @click="getPosterPolicy"
                  />
                </span>
                <div
                    class="up-btn"
                    style="width: 75px; height: 75px; line-height: 80px"
                    @click="getPosterPolicy"
                    v-if="isMoer && posterSrcList.length<1"
                >
                  <i class="el-icon-plus"></i>
                </div>
              </div>
              <input
                  type="file"
                  ref="posterfile"
                  @change="getPosterFile"
                  accept="image/png,image/jpg"
              />
            </div>
          </div>
        </div>
        <div class="common_tab_list">
          <div class="left_names">标题：</div>
          <div class="changButton">
            <el-input style="width: 251px" v-model="posterParams.title" placeholder="请输入内容"></el-input>
          </div>
        </div>
        <div class="common_tab_list">
          <div class="left_names">描述：</div>
          <div class="changButton">
            <el-input type="textarea" style="width: 251px" :rows="4" v-model="posterParams.intro"
                      placeholder="请输入内容"></el-input>
          </div>
        </div>
        <div class="common_tab_list">
          <div class="left_names">排序：</div>
          <div class="changButton">
            <el-input style="width: 251px" v-model="posterParams.seq" placeholder="请输入内容"></el-input>
          </div>
        </div>
      </div>
      <span slot="footer" class="public-dialog-footer">
        <el-button size="medium" @click="dialogVisible = false"
        >取 消</el-button
        >
        <el-button size="medium" type="primary" @click="posterShareSave"
        >提 交</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {ossUpload} from "@utils/filters/upload";

export default {
  name: "shareSet",
  data() {
    return {
      detalisObj: {},
      loading: false,
      shareWay: [
        {
          name: '普通分享',
          value: 'common'
        },
        {
          name: '海报分享',
          value: 'poster'
        }
      ],
      shareValue: 'common',
      srcList: [],
      isMoer: true,
      params: {
        img: '',
        intro: '',
        title: ''
      },
      dialogVisible: false,
      tableData: [],
      posterParams: {},
      posterSrcList: [],
      clickType: ''
    }
  },
  mounted() {
    this.getAppraisalData()
  },
  methods: {
    getPosterPolicy() {
      this.$refs.posterfile.dispatchEvent(new MouseEvent("click"));
    },

    async getPosterFile() {
      const that = this;
      const {data: resData} = await this.$get("/aliyun/oss/sign", {
        headers: {
          isLoading: true,
        },
      });
      if (resData.result != 200) return;
      const addRoutes = await ossUpload(
          that.$refs.posterfile.files[0],
          resData.data,
          "one", //'more','one'
          this.posterSrcList
      );
      this.isMoer = false;
      this.posterSrcList = addRoutes;
      this.posterParams.img = this.posterSrcList[0];
    },

    async handleClick(type, e) {
      this.clickType = type
      if(type=='add'){
        this.posterSrcList = []
        this.posterParams = {}
        this.dialogVisible = true
      }else {
        this.loading = true;
        const {data: resData} = await this.$get("/exam/share/theme/info/" + e.examShareThemeId);
        this.loading = false;
        if (resData.result != 200) return;
        this.posterParams = resData.data
        this.dialogVisible = true
        this.posterSrcList[0] = JSON.parse(JSON.stringify(resData.data.img))
      }
    },
    handleDelete(row) {
      this.$confirm("此操作将永久删除数据, 是否继续?", "提示", {
        type: "warning",
      }).then(async () => {
        const {data: resData} = await this.$delete(
            `/exam/share/theme/info/${row.examShareThemeId}`,
            {
              headers: {
                isLoading: true,
              },
            }
        );
        if (resData.result != 200) return;
        this.getshareListData();
        this.$message.success("删除成功!");
      });
    },
    async changeSwitch(b) {
      const {data: resData} = await this.$put(
          `/exam/share/theme/info/status/${b.examShareThemeId}`
      );
      this.loading = false;
      if (resData.result != 200) return;
      this.$message.success('操作成功');
    },
    async getshareListData() {
      let obj = {
        examInfoId: this.detalisObj.examInfoId,
        shareWay: this.shareValue,
      }
      this.loading = true;
      const {data: resData} = await this.$get("/exam/share/theme/list", {
        params: {
          ...obj,
        },
      });
      this.loading = false;
      if (resData.result != 200) return;
      if (resData.data) {
        if (this.shareValue == 'common') {
          this.params.shareThemeId = resData.data.shareThemeId
          this.params.img = resData.data.img
          this.params.intro = resData.data.intro
          this.params.title = resData.data.title
          this.srcList[0] = JSON.parse(JSON.stringify(resData.data.img))
        } else {
          this.tableData = resData.data
        }
      }
    },

    posterShareSave() {
      if(!this.posterParams.img){
        this.$message.error('请上传海报内容')
        return
      }
      let obj = {}
      if(this.clickType=='add'){
        obj = {
          img: this.posterParams.img,
          examInfoId: this.detalisObj.examInfoId,
          intro: this.posterParams.intro,
          shareWay: this.shareValue,
          title: this.posterParams.title,
          seq: this.posterParams.seq
        }
      }else {
        obj = {
          examShareThemeId:this.posterParams.examShareThemeId,
          shareThemeId:this.posterParams.shareThemeId,
          img: this.posterParams.img,
          examInfoId: this.detalisObj.examInfoId,
          intro: this.posterParams.intro,
          shareWay: this.shareValue,
          title: this.posterParams.title,
          seq: this.posterParams.seq
        }
      }

      this.$confirm("确认保存数据, 是否继续?", "提示", {
        type: "info",
      }).then(async () => {
        if(this.clickType=='add'){
          const {data: resData} = await this.$post(
              "/exam/share/theme/info",
              obj,
              {
                headers: {
                  isLoading: true,
                },
              }
          );
          if (resData.result != 200) return;
          this.dialogVisible = false
          this.getshareListData()
          this.$message.success("操作成功!");
        }else {
          const {data: resData} = await this.$put(
              "/exam/share/theme/info",
              obj,
              {
                headers: {
                  isLoading: true,
                },
              }
          );
          if (resData.result != 200) return;
          this.dialogVisible = false
          this.getshareListData()
          this.$message.success("操作成功!");
        }
      })
    },

    shareSave() {
      if(!this.params.img){
        this.$message.error('请上传图标')
        return
      }
      if(!this.params.title){
        this.$message.error('请输入标题内容')
        return
      }
      if(!this.params.intro){
        this.$message.error('请输入描述内容')
        return
      }

      let obj = {
        img: this.params.img,
        examInfoId: this.detalisObj.examInfoId,
        intro: this.params.intro,
        shareWay: this.shareValue,
        title: this.params.title,
      }
      this.$confirm("确认保存数据, 是否继续?", "提示", {
        type: "info",
      }).then(async () => {
        const {data: resData} = await this.$post(
            "/exam/share/theme/info",
            obj,
            {
              headers: {
                isLoading: true,
              },
            }
        );
        if (resData.result != 200) return;
        this.getshareListData()
        this.$message.success("操作成功!");
      })
    },

    getPolicy() {
      this.$refs.file.dispatchEvent(new MouseEvent("click"));
    },

    async getFile() {
      const that = this;
      const {data: resData} = await this.$get("/aliyun/oss/sign", {
        headers: {
          isLoading: true,
        },
      });
      if (resData.result != 200) return;
      const addRoutes = await ossUpload(
          that.$refs.file.files[0],
          resData.data,
          "one", //'more','one'
          this.srcList
      );
      this.isMoer = false;
      this.srcList = addRoutes;
      this.params.img = this.srcList[0];
    },

    changTabs(e) {
      this.shareValue = e.value
      this.getshareListData()
    },
    /**
     * 获取测评详情
     */
    async getAppraisalData() {
      this.loading = true;

      const {data: resData} = await this.$get(
          `exam/info/${this.$route.query.examId}`
      );
      this.loading = false;
      if (resData.result != 200) return;
      this.detalisObj = resData.data;
      this.getshareListData()
    },
    goBack() {
      this.$router.go(-1);
    },
  }
}
</script>

<style lang="scss" scoped>
.ShareContentBox {
  width: 90%;
  margin: 30px auto 0;
  cursor: pointer;

  .Share_tabs {
    display: flex;
    align-items: center;

    .left_names {
      font-size: 13px;
      width: 80px;
      text-align: right;
    }

    .changButton {
      display: flex;
      align-items: center;
      box-sizing: border-box;

      .shareWayItem {
        width: 100px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        color: #333333;
        font-size: 13px;
        border: 1px solid rgba(0,0,0,0.3);
        //color: #02A7F0;
      }

      .activeShareItem {
        color: #02A7F0;
        border-color: #02A7F0;
      }
    }

    .changButton :last-child {
      border-left: 0;
    }
  }

  .content_tabs {
    margin-top: 20px;


  }

}

.common_tab_list {
  display: flex;
  align-items: center;
  margin-bottom: 20px;

  .left_names {
    width: 80px;
    text-align: right;
    font-size: 13px;
  }

  .changButton {
  }
}


.appraisal-title {
  color: #3a3a3a;
}

.appraisal-center {
  width: 90%;
  margin: 0 auto;
}

.fonts {
  font-size: 14px;
}

.topic-outer {
  width: 100%;
  background: #fff;
  overflow: hidden;
  margin-top: 20px;
  padding-bottom: 30px;
}

.flex-box {
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
}

.fl1 {
  flex: 1;
  -webkit-flex: 1;
}

.glay {
  color: #8492a6;

  i {
    font-style: normal;
    color: #f56c6c;
  }
}

.pub-line {
  margin-top: 30px;
}
</style>